import { SignUpQueryParams } from "@faire/retailer-visitor-shared/views/SignUp/_utils/SignUpQueryParams";
import qs from "query-string";

export const generateBackLinkFromQueryParams = (
  queryParams: SignUpQueryParams
) => {
  const { source, q, filters, product } = queryParams;

  const sourcePage = source
    ?.split(new RegExp("[/?]"))
    .find((item: string) => item !== "");

  if (sourcePage !== "category" && sourcePage !== "search") {
    return undefined;
  }

  const refP = product;
  const queryString =
    filters || q || refP ? `?${qs.stringify({ filters, q, refP })}` : "";
  const backLink = `${source}${queryString}`;
  return backLink;
};
